import { useEffect } from 'react';
import { useLocalObservable } from 'mobx-react-lite';
import { runInAction } from 'mobx';

export function useFetchOne<T>(fetcher: (() => Promise<T>) | undefined) {
  const store = useLocalObservable(() => ({
    data: null as T | null,
    isLoading: false,
    error: null as string | null,
  }));

  useEffect(() => {
    if (!fetcher) return;
    runInAction(() => {
      store.data = null;
      store.isLoading = true;
      store.error = null;
    });
    fetcher()
      .then((data: T) =>
        runInAction(() => {
          store.data = data;
          store.isLoading = false;
        })
      )
      .catch((err: Error) =>
        runInAction(() => {
          store.error = err.message;
          store.isLoading = false;
        })
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps, @eslint-react/exhaustive-deps
  }, []);

  return store;
}
